import { render } from "./MsTrGroup.vue?vue&type=template&id=77bafcc8&scoped=true"
import script from "./MsTrGroup.vue?vue&type=script&lang=js"
export * from "./MsTrGroup.vue?vue&type=script&lang=js"

import "./MsTrGroup.vue?vue&type=style&index=0&id=77bafcc8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77bafcc8"]])

export default __exports__